import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const postForm = async (path, body) => {
  const fd = new FormData();
  fd.append("data", JSON.stringify(body));
  const res = await http.post(path, fd);
  return res.data;
};

export const submitForm = async (type, data, fileGroups = {}) => {
  const body = { ...data };
  Object.entries(fileGroups).forEach(([key, items]) => {
    body[`${key}_ids`] = (items || []).filter((i) => i.status === "done").map((i) => i.id);
  });
  return postForm(`/forms/${type}`, body);
};

export const uploadFile = async (file, purpose, onProgress) => {
  const fd = new FormData();
  fd.append("purpose", purpose);
  fd.append("file", file);
  const res = await http.post("/uploads", fd, {
    onUploadProgress: (e) => e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  });
  return res.data;
};

// Maps API errors to {fieldErrors, message}
export const parseSubmitError = (err) => {
  const status = err.response?.status;
  const detail = err.response?.data?.detail;
  if (status === 422 && Array.isArray(detail)) {
    const fieldErrors = {};
    detail.forEach((d) => { if (d.field) fieldErrors[d.field] = d.msg; });
    return { fieldErrors, message: "Please check the highlighted fields." };
  }
  if (!err.response) return { fieldErrors: {}, message: "We couldn't reach the server. Check your connection, or call 0247 5222 999." };
  return { fieldErrors: {}, message: formatApiError(detail) };
};
